// ------------------------------------------------------------------------
// preload
// ----- BOTH
// ------------------------------------------------------------------------
const preload = () =>{

  history.replaceState(null, null, null);
  window.addEventListener('popstate', function() {

    $('body').addClass('preload');

    setTimeout(function(){
      $('body').removeClass('preload');
    },100);

  }, false);

  $(window).on('load' , function() {
    $("body").removeClass("preload");
  });

};



export {
  preload,
}



// WEBPACK FOOTER //
// ./src/hayamisaori_v0/assets/js/include/module.js